// From: https://github.com/github/hotkey/blob/main/src/macos-symbol-layer.ts.
/**
 * Map of special symbols to the keys that would be pressed (while holding `Option`) to type them on MacOS on an
 * English layout. Most of these are standardized across most language layouts, so this won"t work 100% in every
 * language but it should work most of the time.
 */
export const MACOS_SYMBOL_LAYER_KEYS: Record<string, string> = {
    "¡": "1",
    "™": "2",
    "£": "3",
    "¢": "4",
    "∞": "5",
    "§": "6",
    "¶": "7",
    "•": "8",
    "ª": "9",
    "º": "0",
    "–": "-",
    "≠": "=",
    "⁄": "!",
    "€": "@",
    "‹": "#",
    "›": "$",
    "ﬁ": "%",
    "ﬂ": "^",
    "‡": "&",
    "°": "*",
    "·": "(",
    "‚": ")",
    "—": "_",
    "±": "+",
    "œ": "q",
    "∑": "w",
    "®": "r",
    "†": "t",
    "¥": "y",
    "ø": "o",
    "π": "p",
    "“": "[",
    "‘": "]",
    "«": "\\",
    "Œ": "Q",
    "„": "W",
    "´": "E",
    "‰": "R",
    "ˇ": "T",
    "Á": "Y",
    "¨": "U",
    "ˆ": "I",
    "Ø": "O",
    "∏": "P",
    "”": "{",
    "’": "}",
    "»": "|",
    "å": "a",
    "ß": "s",
    "∂": "d",
    "ƒ": "f",
    "©": "g",
    "˙": "h",
    "∆": "j",
    "˚": "k",
    "¬": "l",
    "…": ";",
    "æ": '"',
    "Å": "A",
    "Í": "S",
    "Î": "D",
    "Ï": "F",
    "˝": "G",
    "Ó": "H",
    "Ô": "J",
    "": "K",
    "Ò": "L",
    "Ú": ":",
    "Æ": '"',
    "Ω": "z",
    "≈": "x",
    "ç": "c",
    "√": "v",
    "∫": "b",
    "µ": "m",
    "≤": ",",
    "≥": ".",
    "÷": "/",
    "¸": "Z",
    "˛": "X",
    "Ç": "C",
    "◊": "V",
    "ı": "B",
    "˜": "N",
    "Â": "M",
    "¯": "<",
    "˘": ">",
    "¿": "?",
};
